import React from 'react';
import { useTranslation } from 'react-i18next';
import AppIcon from '../AppIcon';

interface AiGeneratedBadgeProps {
  visible: boolean;
  className?: string;
  /** Overrides the default hint, which speaks of editing and is wrong on a read-only surface. */
  hint?: string;
}

// Marks a field the AI filled; the caller clears it the moment the user edits that field.
const AiGeneratedBadge: React.FC<AiGeneratedBadgeProps> = ({ visible, className, hint }) => {
  const { t } = useTranslation();
  if (!visible) return null;

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-primary/10 px-2 py-0.5 text-[11px] font-medium text-primary ${className ?? ''}`}
      title={hint ?? t('ai.generatedHint')}
      data-testid="ai-generated-badge"
    >
      <AppIcon name="Sparkles" size={12} aria-hidden="true" />
      {t('ai.generated')}
    </span>
  );
};

export default AiGeneratedBadge;
